import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { SiteLayout } from "@/components/SiteLayout";
import { MemberShell } from "@/components/MemberShell";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/lib/i18n";
import { useMember } from "@/lib/member";
import { api } from "@/lib/api";

export default function MemberProfile() {
  const { t } = useI18n();
  const { member, loading, setMember } = useMember();
  const [name, setName] = useState(member?.name || "");
  const [wa, setWa] = useState(member?.whatsapp || "");
  const [busy, setBusy] = useState(false);

  if (loading) return <SiteLayout><div className="mx-auto max-w-4xl px-5 py-24 text-ink-soft">{t("loading")}</div></SiteLayout>;
  if (!member) return <Navigate to="/member/login" replace />;

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put("/member/profile", { name, whatsapp: wa });
      setMember(r.data);
      toast.success(r.data.link_status === "pending" ? t("pendingLinkTitle") : t("profileSaved"));
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("memberGenericError"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <MemberShell>
      <h2 className="font-display text-2xl tracking-tight">{member.profile_complete ? t("myProfile") : t("completeProfile")}</h2>
      <p className="mt-2 text-sm text-ink-soft max-w-lg">{t("completeProfileSub")}</p>
      <div className="mt-6 max-w-md space-y-4" data-testid="member-profile-form">
        <div>
          <label className="text-xs uppercase tracking-widest text-ink-soft">{t("fullName")}</label>
          <Input data-testid="member-name-input" className="mt-1.5" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-ink-soft">{t("whatsapp")}</label>
          <Input data-testid="member-wa-input" className="mt-1.5" placeholder="0812xxxxxxx" value={wa}
            onChange={(e) => setWa(e.target.value)} />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-ink-soft">Email</label>
          <div className="mt-1.5 text-sm text-ink-soft">{member.email}</div>
        </div>
        <button data-testid="member-profile-save" disabled={busy} onClick={save}
          className="h-11 px-7 rounded-full bg-ink text-cream text-sm hover:bg-lm-red transition-colors disabled:opacity-50">
          {busy ? "…" : t("save")}
        </button>
      </div>
    </MemberShell>
  );
}
